import request from '@core/services/request';

export const internalRatingAPI = {
	downloadRates: (downloadRequest: any, fileName: any) => request.downloadPost(`/InternalRating/DownloadRates`, downloadRequest, fileName),
	downloadTemplate: (fileName: any) => request.download(`/InternalRating/DownloadTemplate`, fileName),
	uploadRates: (uploadRequest: any) => request.post(`/InternalRating/UploadRates`, uploadRequest),
	deleteRate: (deleteRateRequest: any) => request.post(`/InternalRating/DeleteRates`, deleteRateRequest),
	editRate: (editRateRequest: any) => request.post(`/InternalRating/EditRate`, editRateRequest),
};
